import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { filter, map, Observable, of, tap } from "rxjs";
import { KeywordAndDefinitionDto } from "../models/keyword-and-definition-dto";
import { KeywordAndDefinition } from "@app/models/keywordAndDefinition";
import { environment } from "@env/environment";
import { KeywordAndDefinitionPostRequestDto } from "../models/keyword-and-definition-post-request-dto";
import { KeywordAndDefinitionPutRequestDto } from "../models/keyword-and-definition-put-request-dto";

const API_URL = `${environment.api.baseUrl ?? ""}${environment.api.services.glossary}`;


@Injectable()
export class GlossaryService {

    constructor(private _http: HttpClient) {}

    /** */
    fetchKeywordsByLanguageCode(domain: string = "all", languageCode: string): Observable<KeywordAndDefinition[]> {        

        return this._http.get<KeywordAndDefinitionDto[]>(`${API_URL}/textScan/all`, {
            headers: { 'X-API-KEY': environment.api.xApiKey },
            params: { domain: domain }
        }).pipe(
            map((keywordsAndDefinitionsDtos: KeywordAndDefinitionDto[]) => keywordsAndDefinitionsDtos.filter(kadDto => kadDto.langCode === languageCode)),
            map((keywordsAndDefinitionsDtos: KeywordAndDefinitionDto[]) => keywordsAndDefinitionsDtos.map(kadDto => {
                const keyword: KeywordAndDefinition = {
                    keywordId: kadDto.keywordId,
                    keyword: kadDto.keyword,
                    definition: kadDto.definition,
                    languageCode: kadDto.langCode,
                    tag: kadDto.domain
                }

                return keyword;
            }))
        )
    }

    /** */
    fetchAllTags(): Observable<string[]> {
        return this._http.get<KeywordAndDefinitionDto[]>(`${API_URL}/textScan/all`, {
            headers: { 'X-API-KEY': environment.api.xApiKey },
            params: { domain: "all" }
        }).pipe(
            map((keywordsAndDefinitionsDtos: KeywordAndDefinitionDto[]) => {
                const tags: string[] = keywordsAndDefinitionsDtos.map(kadDtos => kadDtos.domain)
                return [...new Set(tags)]
            }),
        )
    }

    /** */
    createKeyword(keywordAndDefinitionPostRequestDto: KeywordAndDefinitionPostRequestDto) {
        return this._http.post<void>(`${API_URL}/textScan`, keywordAndDefinitionPostRequestDto)
    }

    /** */
    updateKeyword(keywordAndDefinitionPutRequestDto: KeywordAndDefinitionPutRequestDto) {
        return this._http.put<void>(`${API_URL}/textScan`, keywordAndDefinitionPutRequestDto)
    }

    /** */
    deleteKeyword(keywordAndDefinitionId: string) {
        return this._http.delete(`${API_URL}/textScan/${keywordAndDefinitionId}`)
    }
}